import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKoophuis = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M5 18.94 14 13l9 5.94V34H5z"
      clipRule="evenodd"
    />
    <path
      fill="#85BDED"
      d="M14 26H9v8h5zM26 28a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    />
    <path
      fill="#fff"
      d="M21.215 20H20v-2h1.215c.434-2.282 2.325-4 4.593-4 1.294 0 2.465.56 3.313 1.464l-1.459 1.368c-.502-.536-1.159-.832-1.854-.832-1.15 0-2.161.823-2.534 2H26v2h-2.726c.373 1.177 1.384 2 2.534 2 .695 0 1.352-.296 1.854-.832l1.46 1.367c-.849.905-2.02 1.465-3.314 1.465-2.268 0-4.159-1.718-4.593-4"
    />
    <path
      fill="#00215B"
      d="m3.277 24.416-.554-.832 9-6 .554.832zM25 12a9 9 0 1 1-9 9h1a8 8 0 1 0 8-8zm0 0a9 9 0 1 1-9 9h1a8 8 0 1 0 8-8z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKoophuis);

export default ForwardRef;
